import { render, staticRenderFns } from "./BrevoWebhookGetStatsActionSettings.vue?vue&type=template&id=bfd66b9a"
import script from "./BrevoWebhookGetStatsActionSettings.vue?vue&type=script&lang=js"
export * from "./BrevoWebhookGetStatsActionSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports